import React, { useState, useEffect } from 'react'
import { bindActionCreators } from "redux";
import { returnType } from "../../Utilities/ReturnType";
import { connect } from "react-redux";
import { GlobalAutoHealing } from "../../Interface/IGlobalAutoHealing";
import { Persona, PersonaSize, PersonaPresence } from '@fluentui/react/lib/Persona';
import { useSearchParams } from 'react-router-dom'
import TicketAssignedTo from "../../TicketAssignedTo/TicketAssignedTo";
import ArticleCategory from "../../ArticleCategory/ArticleCategory";
import { Stack, IconButton, Text } from '@fluentui/react';
import { Checkbox } from '@fluentui/react/lib/Checkbox';
import { Link } from '@fluentui/react/lib/Link';


import "./ContentMarkerPane.css";

const actionCreators = {};

type DispatchProps = typeof actionCreators;

const mapStateToProps = (state: GlobalAutoHealing) => ({
    reviewContentMarker: state.reviewContentMarker,
    replaceContent: state.replaceContent,
    radioSelected: state.radioSelected
});

const storeProps = returnType(mapStateToProps);
type StoreProps = typeof storeProps.returnType;


// const lightPCYColor: IColor = {
//     red: 101,
//     green: 161,
//     blue: 251
// };
// const lightLOBColor: IColor = {
//     red: 97,
//     green: 219,
//     blue: 118
// };
// const lightSUBColor: IColor = {
//     red: 16,
//     green: 189,
//     blue: 255
// };

function ContentMarkerPane(props: StoreProps & DispatchProps) {
    const [search] = useSearchParams();
    const requesturl = search.get('url')

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)
    const [isCategoryDialogOpen, setIsCategoryDialogOpen] = useState<boolean>(false)

    const [RequiredReviewers, setRequiredReviewers] = useState<string>("")
    const [OptionalReviewers, setOptionalReviewers] = useState<string>("")
    const [Manager, setManager] = useState<string>("")
    const [Organization, setOrganization] = useState<string>("")
    const [Category, setCategory] = useState<string>("")
    const [CategoryValue, setCategoryValue] = useState<string>("")
    
    const [PlanningCategory, setPlanningCategory] = useState<string>("")
    const [PlanningCategoryGroup, setPlanningCategoryGroup] = useState<string>("")
    const [PlanningCategoryBusiness, setPlanningCategoryBusiness] = useState<string>("")

    const [ConditionStrings, setConditionStrings] = useState<any>([])
    const [ShowConditionStrings, setShowConditionStrings] = useState<any>([])
    const [IconName, setIconName] = useState<string>("ChevronDown")

    // Content Opportunities ObservableValue
    // const collapsedContentCorpus = new ObservableValue<boolean>(false);
    const [collapsedContentCorpus, setCollapsedContentCorpus] = useState<boolean>(true)
    
    // Ticket Management ObservableValue
    // const collapsedTicket = new ObservableValue<boolean>(false);
    const [collapsedTicket, setCollapsedTicket] = useState<boolean>(true)
    
    // Microsoft Content Baseline ObservableValue
    // const collapsedBaseline = new ObservableValue<boolean>(false);
    const [collapsedBaseline, setCollapsedBaseline] = useState<boolean>(true)

    /**
     * Collapse or expand the Content Opportunities
     */
    function onCollapseContentCorpusClicked() {
        // collapsedContentCorpus.value = !collapsedContentCorpus.value;
        setCollapsedContentCorpus(!collapsedContentCorpus)
    };

    function onCollapseTicketClicked() {
        // collapsedTicket.value = !collapsedTicket.value;
        setCollapsedTicket(!collapsedTicket)
    };

    function onCollapseBaselineClicked() {
        // collapsedBaseline.value = !collapsedBaseline.value;
        setCollapsedBaseline(!collapsedBaseline)
    };

    const onDismiss = () => {
        setIsDialogOpen(false)
    };

    const onCategoryDismiss = () => {
        setIsCategoryDialogOpen(false)
    };

    useEffect(() => {
        if (props.reviewContentMarker) {
            setRequiredReviewers(props?.reviewContentMarker?.TicketInfo?.RequiredReviewers);
            setOptionalReviewers(props?.reviewContentMarker?.TicketInfo?.OptionalReviewers);
            setManager(props?.reviewContentMarker?.TicketInfo?.Manager);
            setOrganization(props.reviewContentMarker?.TicketInfo?.Organization);
            setPlanningCategory(props.reviewContentMarker?.ArticleInfo?.PlanningCategory);
            setPlanningCategoryGroup(props.reviewContentMarker?.ArticleInfo?.PlanningCategoryGroup);
            setPlanningCategoryBusiness(props.reviewContentMarker?.ArticleInfo?.PlanningCategoryBusiness);

            setConditionStrings(props.reviewContentMarker?.CurationInfo?.ConditionStrings);
            if (props.reviewContentMarker?.CurationInfo?.ConditionStrings?.length > 5) {
                setShowConditionStrings(props.reviewContentMarker?.CurationInfo?.ConditionStrings.slice(0, 5))
            } else {
                setShowConditionStrings(props.reviewContentMarker?.CurationInfo?.ConditionStrings)
            }
        }
    }, [props.reviewContentMarker])


    function renderReviews() {
        console.log("radioSelected",props.radioSelected)
        if (props.reviewContentMarker === null) {
            return null;
        }

        if (RequiredReviewers ||
            OptionalReviewers ||
            Manager) {
            return (<>
                <h3>Reviewers</h3>
                <ul>
                    {
                        (RequiredReviewers
                            && !RequiredReviewers.startsWith('Content Automation Service Account')) && <li>Required: <br />
                            <p>
                                <Persona
                                    text={RequiredReviewers}
                                    size={PersonaSize.size24}
                                    presence={PersonaPresence.online}
                                    imageAlt="Annie Lindqvist, status is online"
                                />
                                <a href="Javascript:;" onClick={() => {
                                    setIsDialogOpen(true);
                                }}>Why is it assigned to me?</a>
                            </p>
                        </li>
                    }
                    {
                        ((props?.reviewContentMarker?.TicketInfo?.OptionalAlias !== props?.reviewContentMarker?.TicketInfo?.RequiredAlias)
                            && OptionalReviewers
                            && !OptionalReviewers.startsWith('Content Automation Service Account')) && <li>Optional:  <br />
                            <p>
                                <Persona
                                    text={OptionalReviewers}
                                    size={PersonaSize.size24}
                                    presence={PersonaPresence.online}
                                    imageAlt="Annie Lindqvist, status is online"
                                />
                            </p>
                        </li>
                    }
                    {
                        (Manager
                            && !Manager.startsWith('Content Automation Service Account')) && <li>Manager:  <br />
                            <p>
                                <Persona
                                    text={Manager}
                                    size={PersonaSize.size24}
                                    presence={PersonaPresence.online}
                                    imageAlt="Annie Lindqvist, status is online"
                                />
                            </p>
                        </li>
                    }
                </ul>
            </>)
        }

        return null
    }

    return (
        <div className='markerPane' style={{ marginTop: "9px", maxHeight: "96vh" }}>
            <div style={{ width: "100%", margin: "auto", marginTop: "5px" }}>
                <div></div>
                <Stack tokens={{ childrenGap: 8 }} className="customCardStale">
                    <Stack style={{ marginLeft: "-5px" }} horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
                        <IconButton
                            iconProps={{ iconName: collapsedContentCorpus ? 'ChevronDown' : 'ChevronRight' }}
                            onClick={onCollapseContentCorpusClicked}
                            title="Expand or collapse"
                            ariaLabel="Expand or collapse"
                            styles={{
                                root: {
                                    color: '#000',
                                    fontSize: 12,
                                    marginTop: 2,
                                },
                                icon: {
                                    color: '#000',
                                    fontSize: 12,
                                },
                            }}
                        />
                        <Text variant="large" styles={{ root: { fontWeight: 700 } }}>
                            Content Opportunities
                        </Text>
                    </Stack>

                    {collapsedContentCorpus && (
                        <div className="ms-Grid pane">
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                    <span style={{ textDecoration: "underline", color: "var(--communication-foreground, rgba(0, 90, 158, 1))" }}>
                                        <Link href={requesturl} target="_blank" underline>{props.reviewContentMarker?.ArticleInfo?.Title}</Link>
                                    </span>
                                    <span>
                                        <h4>Content information may be outdated</h4>
                                        <div>The article is identified due to the following recipe:</div>
                                        <div className="rhythm-vertical-1 flex-column" style={{ paddingTop: "5px" }}>
                                            {
                                                ShowConditionStrings?.map((item) => (
                                                    <Checkbox
                                                        checked={item.Checked}
                                                        label={item.ConditionString}
                                                        className="boxColor"
                                                    />
                                                ))
                                            }
                                        </div>

                                        {
                                            ConditionStrings?.length > 5 ?
                                                <Stack horizontal verticalAlign="center" horizontalAlign="end" tokens={{ childrenGap: 4 }}
                                                    style={{ color: "#000", cursor: "pointer" }}>
                                                    <span style={{ marginRight: "-3px" }} onClick={() => {
                                                        const isCollapsed = IconName === "ChevronDown";
                                                        setIconName(isCollapsed ? "ChevronUp" : "ChevronDown");
                                                        setShowConditionStrings(isCollapsed ? ConditionStrings : ConditionStrings.slice(0, 5));
                                                    }}>
                                                        {IconName === "ChevronDown" ? "See more" : "See less"}
                                                    </span>
                                                    <IconButton
                                                        iconProps={{ iconName: IconName }}
                                                        onClick={() => {
                                                            const isCollapsed = IconName === "ChevronDown";
                                                            setIconName(isCollapsed ? "ChevronUp" : "ChevronDown");
                                                            setShowConditionStrings(isCollapsed ? ConditionStrings : ConditionStrings.slice(0, 5));
                                                        }}
                                                        styles={{
                                                            root: {
                                                                color: '#000',
                                                                fontSize: 12,
                                                                marginTop: 2,
                                                            },
                                                            icon: {
                                                                color: '#000',
                                                                fontSize: 12,
                                                            },
                                                        }}
                                                    />
                                                </Stack>
                                         : null
                                        }

                                    </span>

                                    <span>
                                        <h4>Please verify your article information is accurate.</h4>
                                        <div>
                                            Attest that your article informations is accurate and fix any listed policy violations. Once you submit attestation, your article
                                            will be renewed for another {props.reviewContentMarker?.TicketInfo?.RenewDays} days.
                                        </div>
                                    </span>

                                    <span>
                                        <h4>About this content request</h4>
                                        <ul style={{ marginBottom: "10px" }}>
                                            {
                                                props.reviewContentMarker?.TicketInfo?.AboutThisContent?.map((item, index) => {
                                                    return <li key={index}>{item}</li>
                                                })
                                            }
                                        </ul>
                                    </span>
                                    {/* <span>
                                        <div className="PillFlexRow">
                                            {
                                                (PlanningCategory != null && PlanningCategory != "") ?
                                                    <div className="PillBottom">
                                                        <span className="fluentPill" style={{ backgroundColor: "rgb(101, 161, 251)" }}>PCY</span>
                                                        {PlanningCategory}
                                                    </div> : null
                                            }

                                            {
                                                (PlanningCategoryGroup != null && PlanningCategoryGroup != "") ?
                                                    <div className="PillBottom">
                                                        <span className="fluentPill" style={{ backgroundColor: "rgb(97, 219, 118)" }}>LOB</span>
                                                        {PlanningCategoryGroup}
                                                    </div> : null
                                            }

                                            {
                                                (PlanningCategoryBusiness != null && PlanningCategoryBusiness != "") ?
                                                    <div className="PillBottom">
                                                        <span className="fluentPill" style={{ backgroundColor: "rgb(16, 189, 255)" }}>SBU</span>
                                                        {PlanningCategoryBusiness}
                                                    </div> : null
                                            }

                                        </div>
                                    </span> */}

                                </div>
                            </div>
                        </div>
                    )}

                </Stack>
            </div>

            <div className='ticket' style={{ width: "100%", margin: "auto", marginTop: "8px" }}>
                <Stack tokens={{ childrenGap: 8 }} className="customCardStale"
                    // className="flex-grow"
                    // collapsible={true}
                    // collapsed={collapsedTicket}
                    // onCollapseClick={onCollapseTicketClicked}
                    // titleProps={{
                    //     text: "Ticket Management",
                    //     ariaLevel: 1,
                    // }}
                >
                    <Stack style={{ marginLeft: "-5px" }} horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
                        <IconButton
                            iconProps={{ iconName: collapsedTicket ? 'ChevronDown' : 'ChevronRight' }}
                            onClick={onCollapseTicketClicked}
                            title="Expand or collapse"
                            ariaLabel="Expand or collapse"
                            styles={{
                                root: {
                                    color: '#000',
                                    fontSize: 12,
                                    marginTop: 2,
                                },
                                icon: {
                                    color: '#000',
                                    fontSize: 12,
                                },
                            }}
                        />
                        <Text variant="large" styles={{ root: { fontWeight: 700 } }}>
                            Ticket Management
                        </Text>
                    </Stack>

                    {collapsedTicket && (
                        <div className="ms-Grid pane">
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                    {
                                        Organization &&
                                        <>
                                            <h3>Organization</h3>
                                            <ul>
                                                <li>
                                                    {Organization}
                                                </li>
                                            </ul>
                                        </>
                                    }
                                    {
                                        renderReviews()
                                    }
                                    {
                                        (props.reviewContentMarker?.TicketInfo?.WorkItem == null || props.reviewContentMarker?.TicketInfo?.WorkItem.length == 0) ? null :
                                            <>
                                                <h3>Work item</h3>
                                                {
                                                    (RequiredReviewers || OptionalReviewers || Manager) ? null :
                                                        <div style={{ height: "35px", display: "flex", alignItems: "center" }}>
                                                            {/* <VssPersona className="icon-margin vssPersona" /> */}
                                                            <Persona
                                                                size={PersonaSize.size32}
                                                                styles={{ root: { marginLeft: 20 } }}
                                                            />
                                                            <span style={{ lineHeight: "32px" }}>Click to assign a ticket owner</span>
                                                        </div>
                                                }
                                                <ul style={{ marginTop: "7px" }}>
                                                    {
                                                        props.reviewContentMarker?.TicketInfo?.WorkItem?.map((item, index) => {
                                                            return <li key={index} dangerouslySetInnerHTML={{ __html: item }}></li>
                                                        })
                                                    }
                                                </ul>
                                            </>
                                    }

                                </div>
                            </div>
                        </div>
                    )}
                </Stack>
            </div>

            <div style={{ width: "100%", margin: "auto", marginTop: "8px", marginBottom: "20px" }}>
                <Stack tokens={{ childrenGap: 8 }} className="customCardStale"
                    // className="flex-grow"
                    // collapsible={true}
                    // collapsed={collapsedBaseline}
                    // onCollapseClick={onCollapseBaselineClicked}
                    // titleProps={{
                    //     text: "Microsoft Content Baseline",
                    //     ariaLevel: 1,
                    // }}
                >
                    <Stack style={{ marginLeft: "-5px" }} horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
                        <IconButton
                            iconProps={{ iconName: collapsedBaseline ? 'ChevronDown' : 'ChevronRight' }}
                            onClick={onCollapseBaselineClicked}
                            title="Expand or collapse"
                            ariaLabel="Expand or collapse"
                            styles={{
                                root: {
                                    color: '#000',
                                    fontSize: 12,
                                    marginTop: 2,
                                },
                                icon: {
                                    color: '#000',
                                    fontSize: 12,
                                },
                            }}
                        />
                        <Text variant="large" styles={{ root: { fontWeight: 700 } }}>
                            Microsoft Content Baseline
                        </Text>
                    </Stack>

                    {collapsedBaseline && (
                        <div className="ms-Grid pane">
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                    <h3>Internal support article governance best practices</h3>
                                    <ul>
                                        <li dangerouslySetInnerHTML={{ __html: props.reviewContentMarker?.CurationInfo?.InternalSupportArticleGovernanceBestPracticesHtml }}></li>
                                    </ul>
                                    <span>
                                        <h3>Remediation guidance</h3>
                                        <div style={{ marginLeft: "10px" }}>
                                            &nbsp;&nbsp;&nbsp;&nbsp;Attest that your article information is accurate and fix any listed policy violations every {props.reviewContentMarker?.TicketInfo?.RenewDays} days by any of the following actions:
                                        </div>
                                        {/* <ul>
                                    {
                                        props.reviewContentMarker?.CurationInfo?.RemediationGuidanceHtml?.map((item, index) => (
                                            <li key={index} dangerouslySetInnerHTML={{ __html: item }}></li>
                                        ))
                                    }
                                </ul> */}

                                        <p dangerouslySetInnerHTML={{ __html: props.reviewContentMarker?.CurationInfo?.RemediationGuidanceHtml }}></p>

                                    </span>
                                </div>
                            </div>
                        </div>
                    )}

                </Stack>
            </div>

            <div>
                {
                    isDialogOpen ? (
                        <TicketAssignedTo onDismiss={onDismiss} RequiredReviewers={RequiredReviewers} Manager={Manager} onLoadTicketInfo={(ticketInfo) => {
                            setRequiredReviewers(ticketInfo.RequiredReviewers);
                            setManager(ticketInfo.Manager);
                            setOrganization(ticketInfo.Organization);
                        }} />
                    ) : null
                }
            </div>

            <div>
                {
                    isCategoryDialogOpen ? (
                        <ArticleCategory onDismiss={onCategoryDismiss} Category={Category} CategoryValue={CategoryValue} onLoadArticleInfo={(articleInfo) => {
                            switch (Category) {
                                case "PCY":
                                    setPlanningCategory(articleInfo.CategoryValue);
                                    break;
                                case "LOB":
                                    setPlanningCategoryGroup(articleInfo.CategoryValue);
                                    break;
                                case "SBU":
                                    setPlanningCategoryBusiness(articleInfo.CategoryValue);
                                    break;
                                default:
                                    break;
                            }
                        }} />
                    ) : null
                }
            </div>

        </div>
    );
};

export default connect<StoreProps, DispatchProps>(
    mapStateToProps,
    bindActionCreators.bind({}, actionCreators)
)(ContentMarkerPane);
